import React, { useContext, useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import AddPersonModal from './AddPersonModal';
import './giftList.css'
import Notification from './Notification';
import gifImage from '../../images/present4.jpg'
import AppState from '../../context/AppContext';
import { Button, Card, Form, ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import EditPersonModal from "./EditPersonModal";
import GiftListHelp from '../HelpButtons/GiftListHelp'

const GiftList = () => {
    const context = useContext(AppState)
    const [people, setPeople] = useState([]);
    const auth = JSON.parse(sessionStorage.getItem("user"))
    const [giftData, setGiftData] = useState([])
    const [showAddPersonModal, setShowAddPersonModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddForm, setShowAddForm] = useState({});
    const [title, setTitle] = useState('');
    const [editingGiftId, setEditingGiftId] = useState(null);
    const [editingPerson, setEditingPerson] = useState(null)
    const [editGift, setEditingGift] = useState(null)
    const inputRef = useRef(null);
    const [notification, setNotificationState] = useState({
        show: false,
        message: '',
        type: '',
    });
    useEffect( () => {
        const fetchGifts = async () => {
            context.getAllGifts(auth.user._id).then((data) => {
                if(data){
                    setGiftData(data)
                }
            })
        };
        fetchGifts();
        // eslint-disable-next-line
    }, [ notification ] );
    const setNotification = (notification) => {
        setNotificationState({ ...notification, show: true });
        setTimeout(() => {
            setNotificationState({ ...notification, show: false });
        }, 3000);
    };
    const handleAddPerson = (name) => {
        const newPerson = {
            uid: uuidv4(),
            receiver: name,
            user: auth.user._id,
            gifts: [],
        };
        setPeople([...people, newPerson]);
        context.createReciverGift( auth.user._id, newPerson).then((data) => {
            if(data){
                setNotification({
                    show: true,
                    message: `${newPerson.receiver} is successfully added!`,
                    type: 'success',
                });
            }
        })
        setShowAddPersonModal(false)
    };
    const handleEditPerson = (id, name) => {
        const data = {
            receiver: name,
            uid: id
        }
        context.changeReciverName(auth.user._id, data).then((data) => {
            if(data){
                setNotification({
                    show: true,
                    message: `${name} is successfully edited!`,
                    type: 'success',
                });
            }
        })
    };
    const handleAddGift = (personId, title) => {
        setShowAddForm(true)
        const data = {
            newGift: title,
            uid: personId
        }
        context.addGiftInArray(auth.user._id, personId, data).then((data) => {
            if(data){
                setNotification({
                    show: true,
                    message: `Gift is successfully added!`,
                    type: 'success',
                });
                setShowAddForm(false)
                setTitle('')
            }
        })
    };
    const handleDeleteGift = (title,uid) => {
        const data = {
            gift: title,
            uid:uid
        }
        context.deleteSelectedGift(auth.user._id, uid, data)
            .then(giftList => {
                if(giftList){
                    setNotification({
                        show: true,
                        message: `Gift is successfully deleted!`,
                        type: 'success',
                    });
                }
            })
            .catch(error => {
                console.error(error);
            });
    };
    const handleEdit = (id) => {
        setEditingGiftId(id);
    };
    const handleEditGifts = (id) => {
        setEditingGift(id)
    }
    const onClickHandleEditPerson = (id) => {
        setEditingPerson(id)
    }
    const handleDelete = (uid, name) => {
        context.deleteGiftList(auth.user._id, uid).then((response) =>{
            if(response){
                setNotification({
                    show: true,
                    message: `${name} is successfully deleted!`,
                    type: 'success',
                });
            }
        })
    };
    function handleSave( id, value, uid ) {
        const data = {
            oldGift:id,
            newGift:value,
            uid:uid
        }
        context.editSelectedGift(auth.user._id, uid, data).then((data) => {
            if(data){
                setNotification({
                    show: true,
                    message: `Gift is successfully edited!`,
                    type: 'success',
                });
                setEditingGift(null)
            }
        })
    }
    return (
        <div className="container">
            
            {notification.show && (
                <Notification
                    message={notification.message}
                    type={notification.type}
                />
            )}
            <button
                type="button"
                className="btn btn-primary mb-3"
                data-toggle="modal"
                data-target="#addPersonModal"
                onClick={() => setShowAddPersonModal(true)}
            >
                Add Person
            </button>
            <GiftListHelp/>
            <AddPersonModal
                show={showAddPersonModal}
                onHide={() => setShowAddPersonModal(false)}
                onAddPerson={handleAddPerson}
            />
            <div className="row">
                {giftData.map((person) => (
                    <div className="col-4 mb-3" key={person._id}>
                        <Card className="flex" text="dark">
                            <Card.Header className="col">
                                <h5>{person.receiver}</h5>&nbsp;
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    className="float-right"
                                    onClick={() => {
                                        setShowEditModal(true)
                                        handleEdit(person.receiver)
                                        onClickHandleEditPerson(person.uid)
                                    }}
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                </Button>&nbsp;
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    className="float-right"
                                    onClick={()=>handleDelete(person.uid, person.receiver)}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </Card.Header>
                            <ListGroup>
                                <Card.Body>
                                    {person.gifts.map((giftList) => (
                                        <ListGroup.Item key={giftList._id}>
                                            {editGift === giftList.gift  ? (
                                                <Form onSubmit={(event) => {
                                                    event.preventDefault();
                                                    handleSave(giftList.gift, event.target.title.value, person.uid)
                                                }}>
                                                    <Form.Control
                                                        type="text"
                                                        name="title"
                                                        defaultValue={giftList.gift}
                                                        required
                                                    />
                                                </Form>
                                            ) : (
                                                <>
                                                    <Card.Img src={gifImage} alt={"me"} variant="left" className="imageGift" />
                                                    {giftList.gift}
                                                    <div className="giftButtons">
                                                        <Button
                                                            variant="secondary"
                                                            size="sm"
                                                            className="float-right"
                                                            onClick={() => handleEditGifts(giftList.gift)}
                                                        >
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </Button>&nbsp;
                                                        <Button
                                                            variant="secondary"
                                                            size="sm"
                                                            className="float-right"
                                                            onClick={() => handleDeleteGift(giftList.gift,person.uid)}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </Button>
                                                    </div>
                                                </>
                                            )}
                                        </ListGroup.Item>
                                    ))}</Card.Body>
                                <Card.Footer>
                                    {showAddForm[person.uid] ? (
                                        <Form onSubmit={(event) => {
                                            event.preventDefault();
                                            handleAddGift(person.uid,title)
                                            setShowAddForm(false)
                                        }}>
                                            <Form.Control
                                                size="sm"
                                                type="text"
                                                value={title}
                                                ref={inputRef}
                                                className="w-100"
                                                onBlur={() => {
                                                    setShowAddForm({ ...showAddForm, [person.uid]: false })
                                                    setTitle('')
                                                }}
                                                onChange={(event) => setTitle(event.target.value)}
                                                placeholder="Enter gift title"
                                                required
                                            />
                                        </Form>
                                    ) : (
                                        <i
                                            className="pointer"
                                            onClick={() => {
                                                setShowAddForm({ ...showAddForm, [person.uid]: true });
                                                setTimeout(() => {
                                                    inputRef.current.focus();
                                                }, 0);
                                            }}
                                        >
                                            Add Item +
                                        </i>
                                    )}
                                </Card.Footer>
                            </ListGroup>
                            <EditPersonModal
                                show={showEditModal}
                                clicledId={editingGiftId}
                                uid={editingPerson}
                                onEdit={handleEditPerson}
                                onHide={() => setShowEditModal(false)}
                                onSubmit={handleEdit}
                            />
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    );
};
export default GiftList

